import React from 'react';
import PropTypes from 'prop-types';

import MainLayout from '../common/components/MainLayout';

import '../common/scss/_fonts.scss';
import './global.scss';

const App = ({ children }) => (
  <MainLayout>
    {children}
  </MainLayout>
);

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./App/index.js